import React from 'react';
import {Transition} from '@headlessui/react';
import UserFilter from './User';
import LeadSourceFilter from './LeadSource';
import OriginalLeadSource from './OriginalLeadSource';
import StageFilter from './Stage';
import TagFilter from './Tag';
import FormFilter from './Form';
import CollectedFormUrlFilter from './CollectedFormUrl';
import CustomizeItemFilter from './CustomizeItem';
import CityFilter from './City';
import SubCategoryFilter from './SubCategory';
import ListingMarketFilter from './ListingMarket';
import EmloyeeNumberFilter from './EmployeeNumber';
import CapitalFundFilter from './CapitalFund';
import HubspotDealFilter from './HubspotDeal';
import HubspotContactFilter from './HubspotContact';
import SalesforceLeadFilter from './SalesforceLead';
import SalesforceContactFilter from './SalesforceContact';
import Header from '../Header';
import useFilterModalContext from '../useFilterModalContext';
import ExcludedTagFilter from './ExcludedTag';
import InflowDateFilter from './InflowDate';
import ClientPhaseProspectFilter from './ClientPhaseProspect';

const filterComponents: {[key: string]: any} = {
  user: UserFilter,
  leadSource: LeadSourceFilter,
  originalLeadSource: OriginalLeadSource,
  stage: StageFilter,
  tag: TagFilter,
  excludedTag: ExcludedTagFilter,
  form: FormFilter,
  collectedFormUrl: CollectedFormUrlFilter,
  customizeItem: CustomizeItemFilter,
  city: CityFilter,
  subCategory: SubCategoryFilter,
  listingMarket: ListingMarketFilter,
  employeeNumber: EmloyeeNumberFilter,
  capitalFund: CapitalFundFilter,
  hubspotDeal: HubspotDealFilter,
  hubspotContact: HubspotContactFilter,
  salesforceLead: SalesforceLeadFilter,
  salesforceContact: SalesforceContactFilter,
  inflowDate: InflowDateFilter,
  clientPhaseProspect: ClientPhaseProspectFilter,
};

const SkeletonFilter = () => (
  <>
    <Header title="" />
    <div className="bg-c-bg flex-1 rounded-b" />
  </>
);

const Filter = () => {
  const {filterType} = useFilterModalContext();
  const FilterComponent = filterComponents[filterType];

  return (
    <Transition
      show={!!FilterComponent}
      enter="transition-all duration-150"
      enterFrom="left-full"
      enterTo="left-0"
      leave="transition-all duration-150"
      leaveFrom="left-0"
      leaveTo="left-full"
      className="w-full h-full flex flex-col absolute top-0"
      as="div">
      {FilterComponent ? <FilterComponent /> : <SkeletonFilter />}
    </Transition>
  );
};

export default Filter;
